<template>
    <div class="modal-card">
            <header class="modal-card-head">
                <p class="modal-card-title">Create Task</p>
            </header>
            <section class="modal-card-body">
                <div>
        <div class="columns">
            <div class="column is-12 task-meta">
                <o-field label="Title" :type="fieldType('title')" :message="getError('title')">
                    <o-input v-model="task.title" placeholder="Task Title"></o-input>
                </o-field>
            </div>
        </div>
        <div class="columns">
            <div class="column is-6 task-meta">
                <o-field label="Location" :type="fieldType('location')" :message="getError('location')">
                    <o-select placeholder="Select a Task Location" v-model="task.location" expanded>
                        <option :value="null">Not Specified</option>
                        <option
                                v-for="location in taskLocations"
                                :value="location.id"
                                :key="location.id"
                        >
                            {{ location.name }}
                        </option>
                    </o-select>
                </o-field>
                <div v-if="isProjectSelected" class="between-center">
                    <o-field label="Contact" :type="fieldType('contact_id')" :message="getError('contact_id')" class="flex-1">
                        <o-select placeholder="Select a Task Contact" v-model="task.contact_id" expanded>
                            <option :value="null">Not Specified</option>
                            <option
                                    v-for="contact in projectContactsByProjectId(task.project_id)"
                                    :value="contact.id"
                                    :key="contact.id"
                            >
                                {{ contactNameById(contact.id) }}
                            </option>
                        </o-select>
                    </o-field>

                    <div class="field" style="margin: 20px 0 0 5px">
                        <button @click.prevent="isSelectContactModalActive = true" class="button is-primary">
                            Add Contact
                        </button>
                    </div>
                </div>
            </div>
            <div class="column is-6 task-meta">
                <o-field label="Assigned To" :type="fieldType('assignee_id')" :message="getError('assignee_id')">
                    <autocomplete-select type="user" v-model="task.assignee_id" :value="task.assignee_id"/>
                </o-field>
                <div class="between-center" v-if="isProjectSelected">
                    <o-field label="Related To" class="flex-1" :type="fieldType('category_id')" :message="getError('category_id')">
                        <o-select placeholder="Select a Category" @update:modelValue="selectApplication" v-model="selectedApplication" expanded>
                            <option value="" selected>Not Specified</option>
                            <option
                                    v-for="(application, i) in applicationsByProjectId(task.project_id)"
                                    :value="application"
                                    :key="i"
                            >
                                {{ applicationName(application) }}
                            </option>
                        </o-select>
                    </o-field>
                    <div class="field" style="margin: 20px 0 0 10px">
                        <a style="width: 170px" @click="isApplicationModalActive = true" class="button is-primary">Add Application</a>
                    </div>
                </div>
            </div>
        </div>
        <div class="columns">
            <div class="column is-3 task-meta">
                <div class="field">
                    <o-checkbox v-model="task.is_milestone">Is Milestone</o-checkbox>
                </div>
                <div class="field">
                    <o-checkbox v-model="task.is_package_log">Activity is a package log</o-checkbox>
                </div>
                
                
                
                
                <o-field v-if="isApplicationTypeFieldVisible" label="Application Type" :type="fieldType('application_type')" :message="getError('application_type')">
                    <o-select placeholder="Select an Application Type" v-model="task.application_type" expanded>
                        <option value="" selected>Not Specified</option>
                        <option
                                v-for="applicationType in applicationTypes"
                                :value="applicationType.id"
                                :key="applicationType.id">
                            {{ applicationType.name }}
                        </option>
                    </o-select>
                </o-field>
                <o-field v-if="isApplicationIdFieldVisible" label="Application" :type="fieldType('application_id')" :message="getError('application_id')">
                    <o-select placeholder="Select an Application" v-model="task.application_id" expanded>
                        <option :value="null">Not Specified</option>
                        <option
                                v-for="application in applications"
                                :value="application.id"
                                :key="application.id">
                            {{ applicationName(application) }}
                        </option>
                    </o-select>
                </o-field>
                <template v-if="task.category_id == 1">
                    <o-field label="Date Requested">
                        <datepicker :error="getError('date_requested')" v-model="task.date_requested" />
                    </o-field>
                    <o-field label="Date Sent">
                        <datepicker :error="getError('date_sent')" v-model="task.date_sent" />
                    </o-field>
                    <o-field label="Date Received">
                        <datepicker :error="getError('date_received')" v-model="task.date_received" />
                    </o-field>
                </template>
                <o-field label="Date Created">
                    <datepicker :error="getError('date_created')" v-model="task.date_created" :value="task.date_created" />
                </o-field>
                <o-field label="Due Date">
                    <datepicker :error="getError('due_date')" v-model="task.due_date" />
                </o-field>
                <o-field label="Date Completed">
                    <datepicker :error="getError('date_completed')" v-model="task.date_completed" />
                </o-field>
            </div>
            <div class="column is-9">
                <div class="field between-center quill-label-wrapper">
                    <!-- <o-checkbox><strong>Internal Message</strong></o-checkbox> -->
                    <span class="label is-marginless">Detailed explanation of the task</span>
                    <div class="field">
                        <o-switch v-model="task.is_external">External</o-switch>
                    </div>
                </div>
                <article class="media">
                    <div class="media-content quill-media">
                        <div class="field">
                            <quill-editor :content="task.description" :content-type="'text'" @update:content="task.description = $event" :error="getError('description')" />
                        </div>
                        <nav class="level thread-level">
                            <div class="level-left subscribers-multiselect-wrapper" style="width: 350px !important;">
                                <multiselect
                                    :options="activeUsers"
                                    v-model="subscribers"
                                    :close-on-select="false"
                                    :clear-on-select="true"
                                    placeholder="Who will be notified"
                                    track-by="id"
                                    label="full_name"
                                    value-prop="id"
                                    class="input"
                                />
                                <br>
                                <multiselect
                                    :options="projectContactsByProjectId(task.project_id)"
                                    v-model="subscribedContacts"
                                    v-if="task.is_external"
                                    :multiple="true"
                                    :close-on-select="false"
                                    :clear-on-select="true"
                                    :preserve-search="true"
                                    placeholder="Subscribed Contacts to notify"
                                    track-by="id"
                                    label="full_name"
                                    class="input"
                                />
                            </div>
                            <div class="level-right">
                                <div class="level-item">
                                    <uploadcare v-model="task.files" format="object" :multiple="true"/>
                                </div>
                            </div>
                        </nav>
                    </div>
                </article>
            </div>
        </div>

       <o-modal :can-cancel="['escape', 'outside', 'button']" scroll="keep" v-model:active="isSelectContactModalActive" has-modal-card>
            <select-contact-modal @select="handleContactSelect" />
        </o-modal>

       <o-modal :can-cancel="['escape', 'outside', 'button']" scroll="keep" v-model:active="isApplicationModalActive" has-modal-card>
            <application-modal @select="selectApplication" />
        </o-modal>
                </div>
            </section>
            <footer class="modal-card-foot">
                <div class="float-right">
                    <button @click.prevent="handleCreate" class="button is-success">Save</button>
                    <button @click="$parent.$parent.close()" class="button" >Cancel</button>
                </div>
            </footer>
    </div>
</template>

<script>
    import ApplicationModal from './applications/Layout'
    import SelectContactModal from './SelectContact'
    import Datepicker from '../Datepicker'
    import Uploadcare from '../Uploadcare'
    import HandlesForm from '../../mixins/HandlesForm'
    import { mapActions, mapGetters } from 'vuex'
    import Multiselect from '@vueform/multiselect'
import Footer from '../Footer.vue'
    import {QuillEditor} from "@vueup/vue-quill";
    import moment from "moment/moment";

    export default {
        mixins: [HandlesForm],

        components: {
          QuillEditor,
            Multiselect,
            Uploadcare,
            Datepicker,
            ApplicationModal,
            SelectContactModal
        },
        props: {
            project_id: {
                type: Number // change-order, proposal
            },
            project_service_id: {
                type: Number
            },
            application_type: {
                type: String
            },
            application_id: {
                type: Number
            }
        },

        data () {
            return {
                task: {
                    title: '',
                    description: '',
                    location: null,
                    assignee_id: null,
                    creator_id: null,
                    project_id: null,
                    project_service_id: null,
                    contact_id: null,
                    is_external: false,
                    files: [],
                    due_date: null,
                    category_id: '',
                    application_id: '',
                    application_type: '',
                    date_created: moment().format('MM/DD/YYYY'),
                    date_completed: null,
                    is_milestone: true,
                    is_package_log: false,
                },
                selectedApplication: null,
                subscribers: null,
                subscribedContacts: null,
                projectId: null,
                isSelectContactModalActive: false,
                isApplicationModalActive: false,
                comesFromProjectService: false,
                taskLocations: []
            }
        },

        mounted () {
            this.task.creator_id = this.currentUserId

            this.task.project_id = this.project_id
            
            this.task.project_service_id = this.project_service_id

            this.comesFromProjectService = Boolean(this.project_service_id)
            
            this.selectedApplication = this.application_type ? this.applicationByTypeAndId(this.application_type, this.application_id) : null

            if (this.project_id) {
                // this.fetchProjectById(this.projectId) TODO: Review if neef to remove
            }
            this.fetchTaskBasedCompanies().then(res => {
                this.taskLocations = res.data.data
            })
        },

        computed: {
            ...mapGetters([
                'projectContactsByProjectId',
                'applicationsByProjectId',
                'taskLocationNameById',
                'applicationTypes',
                'applicationName',
                'contactNameById',
                'projectNameById',
                'currentProject',
                'currentProjectId',
                'currentUserId',
                'dictionaries',
                'activeUsers',
                'projectById',
                'contacts',
                'projects',
                'projectServicesByProjectId',
                'applicationByTypeAndId'
            ]),

            isProjectSelected () {
                return this.task.project_id
            },

            isApplicationTypeFieldVisible () {
                return this.task.project_id && this.task.category_id == 1
            },

            isApplicationIdFieldVisible () {
                return this.task.category_id == 1 && _.find(this.applicationTypes, (type) => type.id == this.task.application_type)
            },

            applications () {
                return this.task.application_type && this.task.project_id
                    ? this.$store.getters[`${this.task.application_type}s/currentProjectItems`]
                    : []
            },

            // closeModal(arg, value) {
            //     return this.$parent.$parent.$emit('update:active', false) || this.$parent.$emit('update:active', false) || this.$emit('update:active', false)
            // },

            backRoute() {
                return this.projectId
                    ? {name: 'projects.show.tasks', params: {slug: this.projectId}}
                    : {name: 'tasks.index'}
            },
            availableProjectServices(){
                return _.filter(this.projectServicesByProjectId(this.currentProjectId), service => service.type != 'optional' && this.isStatusValid(service.status));
            }
        },

        watch: {
            'task.project_id' (project_id) {
                if (project_id) {
                    this.subscribedContacts = null
                    this.fetchContacts({ project_id })

                    /*this.fetchProjectById(project_id).then(() => {
                        this.setCurrentProjectId(project_id)
                    })*/
                } else {
                    this.task.category_id = this.task.application_type = this.task.application_id = ''
                }
            },

            'task.category_id' (category_id) {
                if (! category_id) {
                    this.task.application_type = this.task.application_id = ''
                }

                if (category_id != 1) {
                    this.task.date_requested = this.task.date_sent = this.task.date_received = ''
                }
0            }
        },

        methods: {
            ...mapActions([
                'createTask',
                'fetchContacts',
                'fetchProjectById',
                'setCurrentProjectId',
                'attachProjectContact',
                'fetchTaskBasedCompanies'
            ]),

            handleCreate () {
                let task = this.task
                task.subscribers = _.map(this.subscribers, 'id')

                task.due_date = task.due_date ? moment(task.due_date).format('YYYY-MM-DD') : null;
                task.date_created = task.date_created ? moment(task.date_created).format('YYYY-MM-DD') : null;
                task.date_completed = task.date_completed ? moment(task.date_completed).format('YYYY-MM-DD') : null;

                if (task.is_external) {
                    task.subscribedContacts = _.map(this.subscribedContacts, 'id')
                } else {
                    task.subscribedContacts = null;
                }

                let submit = this.wrapSubmit(this.createTask)

                submit(task)
                    .then(res => {
                        this.successMessage('Task has been successfull created')
                        this.$parent.$parent.close()
                        return res
                    })
            },

            handleContactSelect(contact, role) {
                this.task.contact_id = contact.id

                if (this.task.project_id) {
                    this.attachProjectContact({
                        project_id: this.task.project_id,
                        contact_id: contact.id,
                        role: role
                    }).then(res => {
                        this.isSelectContactModalActive = false
                        this.successMessage('Contact has been successfull added')
                        return res
                    })
                } else {
                    this.isSelectContactModalActive = false
                    this.successMessage('Contact has been successfull added')
                }
            },

            selectApplication(application) {
                this.selectedApplication = application
                this.task.application_id = application.id
                this.task.application_type = application.type || application.application_type
            },
            isStatusValid(status) {
                return ['approved','not_billable'].includes(status)
            }
        }
    }
</script>
<style>
.modal-card {
  width: 960px; }

.modal-card-foot {
  display: block; }

</style>